import {EngagementId, PaginationArgs, PopulationId} from "platformed-client/types";
import api from "../../../api";
import {PlatformedQueryFilters} from "../..";
import {param, scope, typedQuery} from "../../typing";
import {controlOeForControl} from "./controlOe";
import {engagementSamples, populationSamples, sample, sampleItems} from "./sample";
import {engagementTests, sampleTests, test} from "./test";

export const population = typedQuery(
  ["tprm", "population", param<PopulationId>("populationId")],
  async populationId => {
    return await api.tprm.populations.get(populationId);
  },
);

export const populationRows = typedQuery(
  ["tprm", "populationRows", param<PopulationId>("populationId"), param<PaginationArgs>("pagination")],
  async (populationId, pagination) => {
    return await api.tprm.populations.listRows(populationId, pagination);
  },
);

export const engagementPopulations = typedQuery(
  ["tprm", "engagementPopulations", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.populations.list(engagementId);
  },
);

/**
 * The queries a record replacement leaves stale: an extraction, or the field
 * edit that drops a field. Either replaces the population's rows, and the
 * backend returns every committed sample drawn from it to draft. A test reads
 * its sample's size and state through `SampleMin`, and an OE basis item embeds
 * `TestMin`, so both go stale with the sample. Without an id, the same queries
 * for every population.
 */
export function populationRecordsReplaced(populationId?: PopulationId): PlatformedQueryFilters[] {
  return [
    population.filter(...scope(populationId)),
    populationRows.filter(...scope(populationId)),
    engagementPopulations.filter(),
    populationSamples.filter(...scope(populationId)),
    engagementSamples.filter(),
    sample.filter(),
    sampleItems.filter(),
    test.filter(),
    sampleTests.filter(),
    engagementTests.filter(),
    controlOeForControl.filter(),
  ];
}
